export enum DemandBulkActionExportType {
    Pricing = "PRICING",
    Product = "PRODUCT",
    Variant = "VARIANT",
}
